export const formatDateToBr = (date) => {
  try {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    // Aqui você mantém o -03:00 ou outro offset fixo que deseja aplicar
    const offset = "-03:00";
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offset}`;
  } catch {
    console.error("Erro no formatDatetoBr", date);
  }
  // Retorna a data formatada no padrão YYYY-MM-DDTHH:MM:SS-03:00
};

export const formatOnlyDate = (date) => {
  let d = date instanceof Date ? date : new Date(date);
  if (isNaN(d)) return "";
  // Retorna apenas DD/MM/AAAA
  return d.toLocaleDateString("pt-BR");
};

export const formatDateTimeSecondsBr = (date) => {
  let d = date instanceof Date ? date : new Date(date);
  if (isNaN(d)) return "";
  // DD/MM/AAAA, hh:mm:ss
  return (
    d.toLocaleDateString("pt-BR") +
    ", " +
    d.toLocaleTimeString("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    })
  );
};

export const formatDateTimeMinutesBr = (date) => {
  let d = date instanceof Date ? date : new Date(date);
  if (isNaN(d)) return "";
  // DD/MM/AAAA, hh:mm
  return (
    d.toLocaleDateString("pt-BR") +
    ", " +
    d.toLocaleTimeString("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    })
  );
};
